<template>
    <div class="container-layout">
        <div v-if="!ready" class="row mat32">
            <div class="col-12">
                <div class="admin-header__loading-state">
                    Trwa wczytywanie
                    <div class="mal15 lds-ellipsis">
                        <div />
                        <div />
                        <div />
                    </div>
                </div>
            </div>
        </div>
        <template v-else>
            <panel-info-box v-if="submitSuccess">
                <img src="../assets/images/icons/checkmark-circle.svg" style="max-height: 48px" />
                <p class="text-lg"><b>Dane zostały poprawnie zapisane</b></p>
            </panel-info-box>
            <div class="row">
                <div class="col-12">
                    <panel-competition-form-box>
                        <div class="row w100 mat24">
                            <div class="col-12 col-lg-6">
                                <p class="form-input__label">Ustaw kolor podstawowy</p>
                                <div class="form-input__colorpicker">
                                    <input id="coloris" v-model="form.colourDefault" />
                                </div>
                            </div>

                            <div class="col-12 col-lg-5">
                                <div class="malr24">
                                    <p class="form-input__helper">
                                        Dostosuj wygląd systemu do własnych upodobań. Ustaw kolor podstawowy oraz kolor
                                        rozszerzony i dodaj własne logo. Dzięki temu zintegrujesz wizualnie nasz system
                                        ze swoim kolorami firmowymi.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </panel-competition-form-box>
                    <panel-competition-form-box class="mat16">
                        <div class="row w100 mat24">
                            <div class="col-12 col-lg-6">
                                <p class="form-input__label">Dodaj logo swojej imprezy (plik jpg lub png)</p>
                                <base-input-file
                                    v-model="logo"
                                    class="mat8"
                                    :is-multiple="false"
                                    converter="base64"
                                    accept="image/png, image/jpeg, image/jpg"
                                    hint="Wybierz plik"
                                />
                                <div v-if="form.logoLink" class="mat16">
                                    <p class="form-input__label">Obecne logo</p>
                                    <img :src="form.logoLink" :alt="form.logoFilename" class="mab16 layout-preview" />
                                    <base-button
                                        btn2
                                        short
                                        :loading="loadingLogo"
                                        :disabled="loadingLogo || loadingPoster || loading"
                                        @click="removeLogo"
                                        >Usuń plik</base-button
                                    >
                                </div>
                            </div>
                        </div>
                    </panel-competition-form-box>
                    <panel-competition-form-box class="mat16">
                        <div class="row w100 mat24">
                            <div class="col-12 col-lg-6">
                                <p class="form-input__label">Dodaj plakat swojej imprezy (plik jpg lub png)</p>
                                <base-input-file
                                    v-model="poster"
                                    class="mat8"
                                    :is-multiple="false"
                                    converter="base64"
                                    accept="image/png, image/jpeg, image/jpg"
                                    hint="Wybierz plik"
                                />
                                <div v-if="form.posterLink" class="mat16">
                                    <p class="form-input__label">Obecny plakat</p>
                                    <img :src="form.posterLink" alt="Plakat" class="mab16 layout-preview" />
                                    <base-button
                                        btn2
                                        short
                                        :loading="loadingPoster"
                                        :disabled="loadingPoster || loadingLogo || loading"
                                        @click="removePoster"
                                        >Usuń plik</base-button
                                    >
                                </div>
                            </div>

                            <div class="col-12 col-lg-5">
                                <div class="malr24">
                                    <p class="form-input__helper">
                                        Maksymalny rozmiar pliku: 2,5&nbsp;MB (JPG lub PNG). Wymiary bez sztywnych
                                        ograniczeń — najlepiej sprawdzą się plakaty pionowe o proporcjach od 4:5 do
                                        2:3 (szerokość : wysokość).
                                    </p>
                                </div>
                            </div>
                        </div>
                    </panel-competition-form-box>
                    <div class="col-lg-12 mat16 mab64">
                        <div class="row justify-content-end">
                            <div class="col-12 col-lg-4">
                                <base-button
                                    btn1
                                    :loading="loading"
                                    :disabled="loading || loadingLogo || loadingPoster"
                                    @click="save"
                                    >Zapisz</base-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import axios from 'axios';
    import Coloris from '@melloware/coloris';
    import PanelCompetitionFormBox from '@/components/PanelCompetitionFormBox';
    import PanelInfoBox from '@/components/PanelInfoBox';

    export default {
        name: 'PanelCompetitionSettingLayout',
        components: {
            PanelCompetitionFormBox,
            PanelInfoBox,
        },
        props: {
            id: {
                type: Number,
                default: null,
            },
        },
        data() {
            return {
                ready: false,
                loading: false,
                loadingLogo: false,
                loadingPoster: false,
                submitSuccess: false,
                form: {
                    colourDefault: null,
                },
                errors: null,
                logo: [],
                poster: [],
            };
        },
        watch: {
            submitSuccess(isSuccess) {
                if (isSuccess) {
                    document.querySelector('body').scrollIntoView({
                        top: 0,
                        behavior: 'smooth',
                    });
                }
            },
        },
        created() {
            this.init();
        },
        methods: {
            async init() {
                try {
                    const response = await axios.get(`/panel/competitions/${this.id}/layout`);
                    this.form = response || { colourDefault: null };
                    this.ready = true;
                    this.$nextTick(() => {
                        Coloris.init();
                        Coloris({ el: '#coloris' });
                    });
                } catch (e) {
                    this.errors = e;
                    this.form = { colourDefault: null };
                    this.ready = true;
                    this.$nextTick(() => {
                        Coloris.init();
                        Coloris({ el: '#coloris' });
                    });
                }
            },
            async save() {
                this.loading = true;
                this.submitSuccess = false;
                const promises = [];

                promises.push(
                    axios({
                        method: 'post',
                        url: '/panel/layout',
                        data: {
                            competition: this.id,
                            colourDefault: this.form.colourDefault,
                        },
                    })
                );

                if (this.logo && this.logo.length > 0) {
                    promises.push(
                        axios({
                            method: 'post',
                            url: `/panel/competitions/${this.id}/files/logo`,
                            data: this.logo[0],
                        })
                    );
                }

                if (this.poster && this.poster.length > 0) {
                    promises.push(
                        axios({
                            method: 'post',
                            url: `/panel/competitions/${this.id}/files/poster`,
                            data: this.poster[0],
                        })
                    );
                }

                await Promise.all(promises).catch((err) => {
                    this.errors = err;
                });

                this.logo = [];
                this.poster = [];
                this.loading = false;
                this.submitSuccess = true;
                await this.init();
            },
            async removeLogo() {
                this.loadingLogo = true;
                this.submitSuccess = false;
                try {
                    await axios({
                        method: 'delete',
                        url: `/panel/competitions/${this.id}/files/logo`,
                    });
                    await this.init();
                    this.submitSuccess = true;
                } catch (err) {
                    this.errors = err;
                } finally {
                    this.loadingLogo = false;
                }
            },
            async removePoster() {
                this.loadingPoster = true;
                this.submitSuccess = false;
                try {
                    await axios({
                        method: 'delete',
                        url: `/panel/competitions/${this.id}/files/poster`,
                    });
                    await this.init();
                    this.submitSuccess = true;
                } catch (err) {
                    this.errors = err;
                } finally {
                    this.loadingPoster = false;
                }
            },
        },
    };
</script>

<style src="@melloware/coloris/dist/coloris.css"></style>
<style>
    .form-input__colorpicker .clr-field button {
        width: 32px;
        height: 32px;
        left: 6px;
        right: auto;
        border-radius: 4px;
        z-index: 22;
    }
    .form-input__colorpicker .clr-field {
        width: 100%;
    }
    .form-input__colorpicker .clr-field input {
        padding-left: 48px;
        position: relative;
        min-height: 48px;
        border: solid 1px var(--color-slate-two);
        border-radius: 4px;
        width: 100%;
        box-sizing: border-box;
    }
</style>
<style scoped>
    .container-layout {
        margin-left: 0;
        width: 100%;
    }
    .form-input__label {
        margin-bottom: 6px;
    }
    .layout-preview {
        max-width: 100%;
        max-height: 200px;
        display: block;
    }
    @media (max-width: 991px) {
        .form-input__helper {
            margin: 8px 0;
        }
    }
    @media (min-width: 992px) {
        .container-layout {
            margin-left: 30px;
        }
        .malr24 {
            margin-left: 24px;
        }
    }
</style>
